import {Injectable, EventEmitter} from "@angular/core";
import {Http} from "@angular/http";
import {Authentication} from "./api/authentication/api.service";
import {Settings} from "./api/settings.model";
import {MessagesEndpoint} from "./api/messages/api.service";
import {AttachmentsEndpoint} from "./api/attachments/api.service";
import {RequestLog} from "./api/requestlog.model";
import {MessagecentralsEndpoint} from "./api/messagecentrals/api.service";
import {LanguagesEndpoint} from "./api/languages/api.service";
import {UsersEndpoint} from "./api/users/api.service";
import {CompaniesEndpoint} from "./api/companies/api.service";
import {RolesEndpoint} from "./api/roles/api.service";
import {PermissionsEndpoint} from "./api/permissions/api.service";
import {MeEndpoint} from "./api/me/me.service";
import {AuditsEndpoint} from "./api/audits/api.service";
import {BaseEndpoint} from "./api/bases/api.service";

@Injectable()
export class Api {
    protected settings: Settings;
    protected auditsEndpointService: AuditsEndpoint;
    protected authenticationService: Authentication;
    protected messagesEndpoint: MessagesEndpoint;
    protected attachmentsEndpoint: AttachmentsEndpoint;
    protected messagecentralsEndpoint: MessagecentralsEndpoint;
    protected languagesEndpoint: LanguagesEndpoint;
    protected usersEndpoint: UsersEndpoint;
    protected companiesEndpoint: CompaniesEndpoint;
    protected rolesEndpoint: RolesEndpoint;
    protected permissionsEndpoint: PermissionsEndpoint;
    protected meEndpoint: MeEndpoint;
    protected baseEndpoint: BaseEndpoint;

    protected requests: RequestLog[] = [];

    public latestStatusCode: EventEmitter<number> = new EventEmitter();

    constructor(private http: Http) {
        var apiUrl = null;
        let debug  = process.env.ENV === 'development';

        if (process.env.API_URL && debug === true) {
            apiUrl = process.env.API_URL;
        } else {
            apiUrl = '//api.' + window.location.hostname;
        }

        this.settings = new Settings(this, apiUrl, debug, this.latestStatusCode);
    }

    logRequest(request: RequestLog): void {
        this.requests.push(request);
    }

    getRequestLog(): RequestLog[] {
        return this.requests;
    }

    clearRequestLog(): void {
        this.requests = [];
    }

    setToken(token?: string) {
        this.settings.token = token;
    }

    audits(): AuditsEndpoint {
        if (!this.auditsEndpointService) {
            this.auditsEndpointService = new AuditsEndpoint(this.http, this.settings);
        }

        return this.auditsEndpointService;
    }

    authentication(): Authentication {
        if (!this.authenticationService) {
            this.authenticationService = new Authentication(this.http, this.settings);
        }

        return this.authenticationService;
    }

    attachments(): AttachmentsEndpoint {
        if (!this.attachmentsEndpoint) {
            this.attachmentsEndpoint = new AttachmentsEndpoint(this.http, this.settings);
        }

        return this.attachmentsEndpoint;
    }

    messages(): MessagesEndpoint {
        if (!this.messagesEndpoint) {
            this.messagesEndpoint = new MessagesEndpoint(this.http, this.settings);
        }

        return this.messagesEndpoint;
    }

    messagecentrals(): MessagecentralsEndpoint {
        if (!this.messagecentralsEndpoint) {
            this.messagecentralsEndpoint = new MessagecentralsEndpoint(this.http, this.settings);
        }

        return this.messagecentralsEndpoint;
    }

    languages(): LanguagesEndpoint {
        if (!this.languagesEndpoint) {
            this.languagesEndpoint = new LanguagesEndpoint(this.http, this.settings);
        }

        return this.languagesEndpoint;
    }

    users(): UsersEndpoint {
        if (!this.usersEndpoint) {
            this.usersEndpoint = new UsersEndpoint(this.http, this.settings);
        }

        return this.usersEndpoint;
    }

    companies(): CompaniesEndpoint {
        if (!this.companiesEndpoint) {
            this.companiesEndpoint = new CompaniesEndpoint(this.http, this.settings);
        }

        return this.companiesEndpoint;
    }

    roles(): RolesEndpoint {
        if (!this.rolesEndpoint) {
            this.rolesEndpoint = new RolesEndpoint(this.http, this.settings);
        }

        return this.rolesEndpoint;
    }

    permissions(): PermissionsEndpoint {
        if (!this.permissionsEndpoint) {
            this.permissionsEndpoint = new PermissionsEndpoint(this.http, this.settings);
        }

        return this.permissionsEndpoint;
    }

    me(): MeEndpoint {
        if (!this.meEndpoint) {
            this.meEndpoint = new MeEndpoint(this.http, this.settings);
        }

        return this.meEndpoint;
    }

    bases(): BaseEndpoint {
        if (!this.baseEndpoint) {
            this.baseEndpoint = new BaseEndpoint(this.http, this.settings);
        }

        return this.baseEndpoint;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api.service.ts